window.showSignIn = function(){
  $(".js-sign-in").removeClass("hidden");
  $(".js-sign-up").addClass("hidden");
  // setTimeout - because problem with ie and firefox setting focus
  setTimeout(function() { $(".js-sign-in-email").focus(); }, 0);
}

window.showSignUp = function(){
  $(".js-sign-up").removeClass("hidden");
  $(".js-sign-in").addClass("hidden");
  // setTimeout - because problem with ie and firefox setting focus
  setTimeout(function() { $(".js-sign-up-email").focus(); }, 0);
}
